export class UserInformation {
  adsId!: string;
  displayName!: string;
  emailAddress!: string;
  isActive!: boolean;
  login!: string;
  isContainer!: boolean;
  constructor(adsIdentity: string, displayName: string,emailAddress:string) {
    this.adsId = adsIdentity;
    this.displayName = displayName;
    this.emailAddress = emailAddress;
  }
}
